import React, { useState, useEffect } from "react";
import AboutUsBanner from "../assets/main_gold_loan_banner.webp";
import AboutUsBannerMobile from "../assets/main_gold_loan_banner_mobile.webp";
import FaQ from "./FaQ";
import "bootstrap/dist/css/bootstrap.min.css";
import checkIcon from "../assets/budget-alt.svg";
import rupeeIcon from "../assets/rupeeicon.svg";
import docIcon from "../assets/task-checklist.svg";
import coinIcon from "../assets/tax-alt.svg";
import EMICalculator from "../components/Emi";
import "../App.css";

export default function GoldLoan() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const loans = [
    {
      title: "Regular Gold Loan",
      desc: "Unlock business funds against office/shop premises.",
      details: [
        { label: "Loan Amount", value: "₹25,000 – ₹3 Lakhs" },
        { label: "Tenure", value: "1 – 5 years" },
        { label: "Interest Rate", value: "11% p.a." },
      ],
    },
    {
      title: "Business Gold Loan",
      desc: "Finance operations using your industrial property.",
      details: [
        { label: "Loan Amount", value: "₹1 Lakh – ₹25 Lakhs" },
        { label: "Tenure", value: "1 – 7 years" },
        { label: "Interest Rate", value: "9% p.a." },
      ],
    },
    {
      title: "Emergency Gold Loan",
      desc: "Get a loan against assured rental income.",
      details: [
        { label: "Loan Amount", value: "₹1 Lakh – ₹50 Lakhs" },
        { label: "Tenure", value: "1 – 5 years" },
        { label: "Interest Rate", value: "10% p.a." },
      ],
    },
    {
      title: "Gold Loan Overdraft",
      desc: "Borrow additional funds on your existing LAP.",
      details: [
        { label: "Loan Amount", value: "₹50,000 – ₹25 Lakhs" },
        { label: "Tenure", value: "1 – 7 years" },
        { label: "Interest Rate", value: "8.5% p.a." },
      ],
    },
    {
      title: "Gold Loan Against Property",
      desc: "Borrow additional funds on your existing LAP.",
      details: [
        { label: "Loan Amount", value: "₹50,000 – ₹25 Lakhs" },
        { label: "Tenure", value: "1 – 7 years" },
        { label: "Interest Rate", value: "8.5% p.a." },
      ],
    },
  ];

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  const bannerImage = isMobile ? AboutUsBannerMobile : AboutUsBanner;
  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://shubhpaisa.com/SeoBix/seo_injection.php?webid=524fa94a44850852fe5b6a9e70bfe6cd&url=${encodedUrl}&baseUrl=https%3A%2F%2Fshubhpaisa.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <>
      {/* hero section */}
      <section className="w-100 position-relative">
        <div className="container-fluid p-0">
          <div
            className="position-relative w-100 d-flex hero-banner"
            style={{
              minHeight:
                windowWidth <= 768
                  ? "550px" // Mobile
                  : windowWidth <= 1024
                  ? "400px" // Tablet
                  : windowWidth <= 1600
                  ? "600px" // Medium Desktop
                  : "750px", // Large Desktop
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundImage: `url(${bannerImage})`,
              alignItems: windowWidth <= 768 ? "flex-start" : "center",
              paddingTop: windowWidth <= 768 ? "60px" : "0",
            }}
          >
            {/* Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1,
              }}
            ></div>

            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-1"></div>
                <div
                  className="col-10"
                  style={{
                    position: "relative",
                    zIndex: 2,
                    width:
                      windowWidth <= 768
                        ? "90%"
                        : windowWidth <= 1024
                        ? "70%"
                        : "55%",
                    textAlign: windowWidth <= 768 ? "center" : "left",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: windowWidth <= 768 ? "center" : "flex-start",
                  }}
                >
                  <div className="text-start">
                    <h1
                      className="fw-semibold mb-2"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "20px"
                            : windowWidth <= 1024
                            ? "30px"
                            : "42px",
                        textAlign: "left",
                        lineHeight: "1.2",
                        fontWeight: "700",
                        color: "#2353A6",
                      }}
                    >
                      Get Instant Gold Loans at <br /> Attractive Interest Rates
                    </h1>

                    <p
                      className="mb-4"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "14px"
                            : windowWidth <= 1024
                            ? "16px"
                            : "16px",
                        textAlign: "left",
                        maxWidth: "500px",
                        fontWeight: "300",
                      }}
                    >
                      Turn your gold into opportunity with quick disbursal,
                      minimal paperwork, and 100% safe storage.
                    </p>

                    <div className="text-start">
                      <button
                        style={{
                          ...styles.button,
                          padding: isMobile ? "10px 20px" : "12px 28px",
                          fontSize: isMobile ? "14px" : "16px",
                          backgroundColor: "#2353A6",
                          color: "#fff",
                          display: "inline-block",
                        }}    onClick={() => {
                          window.open("https://instantloan.shubhpaisa.com/", "_blank");
                        }}
                      >
                        Apply Now
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-1"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About vehicle loan */}
      <section
        className="aboutPersonalSec"
        style={{
          background:
            "linear-gradient(180deg, #cfd3f540 0%, #FFF 50%, #b3b8e940 100%)",
          padding: "80px 0",
        }}
      >
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h2 className="mb-5">About Gold Loan</h2>

            <div className="row g-4">
              <div className="col-12 col-md-6">
                <p
                  style={{
                    fontSize: "1.2rem",
                    color: "#333",
                    lineHeight: "1.4",
                  }}
                >
                  A gold loan or loan against gold is a secured loan that
                  customers can avail by pledging their gold ornaments, such as
                  jewellery. It is one of the fastest and most convenient ways
                  to meet urgent financial needs and serves as a reliable
                  alternative to traditional banking loans.
                </p>

                <p
                  style={{
                    fontSize: "1.2rem",
                    color: "#333",
                    lineHeight: "1.4",
                  }}
                >
                  At Shubh Paisa, we ensure a seamless borrowing experience with
                  instant approvals, transparent interest rates, and complete
                  customer satisfaction. With quick loan disbursal and a
                  customer-first approach, we make borrowing easy, safe, and
                  stress-free.
                </p>
              </div>

              <div className="col-12 col-md-6">
                <p
                  style={{
                    fontSize: "1.2rem",
                    color: "#333",
                    lineHeight: "1.4",
                  }}
                >
                  We offer the best gold loans in India, starting from as low as
                  ₹5,000 up to ₹5 Crores, catering to both small and large
                  financial requirements.
                </p>

                <div style={{ lineHeight: "1.4", color: "#333" }}>
                  <p style={{ fontSize: "1.2rem", marginBottom: "0.4rem" }}>
                    Gold Loan @ Home – Convenience in 3 Easy Steps
                  </p>

                  <p style={{ fontSize: "1.2rem", marginBottom: "0.4rem" }}>
                    Now get a gold loan at the comfort of your home with our
                    Gold Loan@Home service:
                  </p>

                  <div style={{ fontSize: "1.2rem" }}>
                    <p style={{ margin: "0.2rem 0" }}>
                      1. Request – Apply online or schedule a home visit.
                    </p>
                    <p style={{ margin: "0.2rem 0" }}>
                      2. Valuation – Certified experts evaluate your gold at
                      your doorstep.
                    </p>
                    <p style={{ margin: "0.2rem 0" }}>
                      3. Instant Disbursal – Get money credited instantly to
                      your bank account.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* CARDS */}
            <div className="row justify-content-center">
              <div className="col-12 col-md-10" style={{ maxWidth: "1100px" }}>
                <div className="row justify-content-center text-center mt-4 g-4">
                  <div className="col-6 col-md-3 mb-4">
                    <div className="cardBox ">
                      <img src={checkIcon} width="40" height="40" alt="" />
                      <p>Quick approval within minutes</p>
                    </div>
                  </div>

                  <div className="col-6 col-md-3 mb-4">
                    <div className="cardBox ">
                      <img src={rupeeIcon} width="50" height="50" alt="" />
                      <p>No hidden fees</p>
                    </div>
                  </div>

                  <div className="col-6 col-md-3 mb-4">
                    <div className="cardBox">
                      <img src={docIcon} width="40" height="40" alt="" />
                      <p>Minimal documentation (simple KYC)</p>
                    </div>
                  </div>

                  <div className="col-6 col-md-3 mb-4">
                    <div className="cardBox">
                      <img src={coinIcon} width="40" height="40" alt="" />
                      <p>Balance transfer at lower rates</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Types of vehicle loans */}
      <section
        className=""
        style={{
          background: "#FFF4D1",
          padding: "80px 0",
        }}
      >
        <div className="row justify-content-center">
          <div className="col-10">
            <h2 className="text-center mb-5 " style={{ color: "#333" }}>
              Types of Gold Loan
            </h2>

            <div className="row justify-content-start">
              {loans.map((loan, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-12 mt-3">
                  <div
                    className="p-4"
                    style={{
                      background: "#fff",
                      borderRadius: "10px",
                      border: "none",
                      height: "100%",
                    }}
                  >
                    <h5 className="mb-2">{loan.title}</h5>
                    <p style={{ fontSize: "0.8rem", color: "#555" }}>
                      {loan.desc}
                    </p>

                    <div
                      className="p-2 mb-2"
                      style={{
                        border: "1px solid #E0E0E0",
                        borderRadius: "8px",
                        background: "#fff",
                      }}
                    >
                      {loan.details.map((item, i) => (
                        <p
                          key={i}
                          className="mb-1"
                          style={{ fontSize: "0.9rem", color: "#333" }}
                        >
                          <strong>{item.label}:</strong>{" "}
                          <span style={{ color: "grey" }}>{item.value}</span>
                        </p>
                      ))}
                    </div>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-primary"
                        style={{
                          background: "#002E94",
                          border: "none",
                          fontSize: "0.9rem",
                          padding: "6px 16px",
                        }}   onClick={() => {
                          window.open("https://instantloan.shubhpaisa.com/", "_blank");
                        }}
                      >
                        Apply Now →
                      </button>
                      {/* <button
                        className="btn btn-outline-primary"
                        style={{
                          borderColor: "#002E94",
                          color: "#002E94",
                          fontSize: "0.9rem",
                          padding: "6px 16px",
                        }}
                      >
                        Learn More
                      </button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Service Charge  */}

      <div className="container my-5">
        <div className="text-center mb-4">
          <h5 className="fw-semibold">Service Charges relating to Gold Loan</h5>
          <p
            className="text-muted text-center mx-auto"
            style={{ maxWidth: "500px" }}
          >
            Know all service charges in advance, including processing and
            valuation, for a smooth loan experience.
          </p>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered align-middle text-start">
            <thead className="table-primary text-start ">
              <tr>
                <th style={{ width: "5%" }}>No.</th>
                <th style={{ width: "40%" }}>Type of Charges</th>
                <th style={{ width: "25%" }}>Applicability</th>
                <th style={{ width: "30%" }}>Rate of Charges</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Processing Charges (Fresh Loan)</td>
                <td>All customers</td>
                <td>0.50% – 1% of loan amount (min ₹200 – max ₹1,000)</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Top-up Processing Charges</td>
                <td>Existing gold loan holders</td>
                <td>1% – 2% of enhanced loan amount</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Security Charges</td>
                <td>All customers</td>
                <td>₹200 – ₹1,000 (depending on loan amount & tenure)</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Valuation Charges</td>
                <td>All customers</td>
                <td>₹100 – ₹300 (based on quantity & type of ornaments)</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Renewal / Closure Charges</td>
                <td>All customers</td>
                <td>₹100 – ₹500</td>
              </tr>
              <tr>
                <td>6</td>
                <td>SMS / Intimation Charges</td>
                <td>All customers</td>
                <td>₹5 – ₹10 per quarter</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Safe Custody Charges (if applicable)</td>
                <td>All customers</td>
                <td>₹5 per gram per month (payable at closure/renewal)</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Doorstep Gold Loan Service (Optional)</td>
                <td>Select cities</td>
                <td>Up to ₹500 per visit</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Legal / Documentation / Stamp Duty (if req.)</td>
                <td>State-specific</td>
                <td>As per actuals levied by respective state governments</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-primary px-4 py-2">Download PDF</button>
        </div>
      </div>

      {/* Eleglibility section */}

      <div
        className="row justify-content-center eligibility-Section"
        style={{ marginTop: "5rem", marginBottom: "4rem" }}
      >
        <div className="col-lg-10">
          <h3 className="mb-5">Eligibility & Documents Required</h3>

          <div className="row g-4">
            <div className="col-12 col-md-6">
              <p
                style={{ fontSize: ".9rem", color: "#333", lineHeight: "1.8" }}
              >
                When applying for a personal loan at Shubh Paisa, the
                eligibility conditions are kept simple to ensure that
                individuals from different backgrounds can easily access funds
                when needed. Any Indian resident aged between 21 and 60 years is
                eligible to apply. This includes salaried employees,
                self-employed professionals, business owners, and government or
                private sector workers with a stable source of income. Since
                personal loans are unsecured, no collateral is required, but
                lenders generally assess factors like credit score, income
                level, employer, and repayment history before sanctioning the
                loan.
              </p>

              <p
                style={{ fontSize: ".9rem", color: "#333", lineHeight: "1.8" }}
              >
                To complete the process, applicants are required to submit a few
                standard documents. For identity proof, one can provide Aadhaar,
                PAN, Passport, Voter ID, or Driving License. For address proof,
                documents such as Aadhaar, Passport, Driving License, recent
                utility bills (electricity, water, gas) or Ration Card are
                accepted. In addition, proof of income is mandatory — salary
                slips and bank statements for salaried applicants, or ITR and
                financial statements for self-employed individuals. Along with
                these, two recent passport-size photographs are required at the
                time of application.
              </p>
            </div>

            <div className="col-12 col-md-6">
              <p
                style={{ fontSize: ".9rem", color: "#333", lineHeight: "1.8" }}
              >
                All applications and documents are verified through secure
                systems, and once approved, the loan amount is directly
                disbursed to the vehicle dealer or seller, ensuring a quick and
                transparent process. The simplified eligibility and minimal
                documentation requirements make availing a vehicle loan fast,
                safe, and hassle-free, helping you drive home your dream
                two-wheeler, four-wheeler, or commercial vehicle with ease.
              </p>
            </div>
          </div>
        </div>
      </div>

      <EMICalculator />
      <FaQ />
    </>
  );
}

const styles = {
  button: {
    border: "none",
    fontWeight: "500",
    borderRadius: "5px",
    cursor: "pointer",
  },
};
